<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TÍTULO E BOTÕES JUNTOS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <div class="logo" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        account_box
                    </mat-icon>
                    <span class="logo-text h1">
                        Clientes
                    </span>
                </div>

                <!-- BOTÕES ALINHADOS IMEDIATAMENTE APÓS O TÍTULO -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                    <!-- Botão Consultar -->
                    <button mat-mini-fab 
                            color="accent"
                            matTooltip="Consultar Cliente"
                            (click)="openFiltro()"
                            *ngIf="_actions.buttonView.enabled">
                        <mat-icon>search</mat-icon>
                    </button>
                    
                    <!-- Botão Exportar -->
                    <button mat-mini-fab 
                            color="accent"
                            matTooltip="Exportar Clientes"
                            (click)="getAllExport()"
                            *ngIf="_actions.buttonExport.enabled">
                        <mat-icon>cloud_download</mat-icon>
                    </button>
                    
                    <!-- Botão Upload -->
                    <button mat-mini-fab 
                            color="accent"
                            matTooltip="Upload Clientes"
                            (click)="openUpload()"
                            *ngIf="_actions.buttoUploadPosition.enabled">
                        <mat-icon>cloud_upload</mat-icon>
                    </button>
                    
                    <!-- Botão Adicionar -->
                    <button mat-mini-fab 
                            color="accent"
                            matTooltip="Adicionar Cliente"
                            (click)="cadastroCliente()"
                            *ngIf="_actions.buttonNew.enabled">
                        <mat-icon>add_circle</mat-icon>
                    </button>
                    
                    <!-- Botão Ficha Cadastral -->
                    <button mat-mini-fab 
                            color="accent"
                            matTooltip="Ficha Cadastral"
                            (click)="cadastroCompleto()"
                            *ngIf="_actions.buttonNew.enabled">
                        <mat-icon>assignment</mat-icon>
                    </button>
                </div>
            </div>

            <!-- CAMPO DE PESQUISA  -->
            <div class="search-wrapper mx-32 mx-md-0" fxFlex>
                <div class="search" fxLayout="row" fxLayoutAlign="start center">                    
                    <input 
                        #filter 
                        placeholder="Buscar Por Nome, CPF ou Conta"
                        [formControl]="search"
                        (keyup)="onEnter(filter.value)"
                        (keyup.enter)="onEnter(filter.value)"
                    >
                    <mat-icon 
                        style="cursor: pointer;" 
                        (click)="getAll()"
                    >
                        search
                    </mat-icon>
                </div>
            </div>

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <div class="label-30-dias">
                <div style="width:35%; text-align: left">
                    Data da última atualização: {{ lastDateUpdate | date:'dd/MM/yyyy'}}
                </div>
                <div style="display:flex; min-width: 15%">
                    <div class="quadrado-esquerdo"></div>
                    <div>
                        <span style="font-size: 10px;">ÚLTIMOS 30 DIAS</span>
                        <mat-icon>arrow_drop_down</mat-icon>
                    </div>                        
                    <div class="quadrado-direito"></div>                    
                </div>
            </div>            
            <ngx-datatable 
                #table
                [loadingIndicator]="loadingIndicator"
                class='material' 
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'
                [rowClass]="getRowClass"
                [limit]="params.per_page"
                (sort)="onSort($event)"
            >

                <ngx-datatable-column name="Nome do Cliente" prop="nome" [sortable]="true" [width]="300">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span style="font-size:16px; margin-bottom: 1px; color: #a1b1c2">
                            {{row.numero_xp != '' && row.numero_xp != null ? row.numero_xp : 'SEM CONTA'}}
                        </span><br />
                        <span style="font-size:14px;">{{ row.nome }}</span> 
                    </ng-template>
                </ngx-datatable-column>
               
                <ngx-datatable-column name="Assessor" prop="assessor" [sortable]="true" *ngIf='usuario.role_id != 5'>
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span> {{row.assessor?.name}}</span><br/>
                        <span> {{row.escritorio?.nome_fantasia}} </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Patrimônio Atual" prop="valor_patrimonio_atual" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-valor_patrimonio_atual="value" ngx-datatable-cell-template>
                        R$ {{ valor_patrimonio_atual | number : '1.2-2'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ganho/Perda" prop="volume_geral" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>

                        <div                            
                            [ngClass]="{
                                'negativo': getGanhoPerda(row) < 0 , 
                                'positivo': getGanhoPerda(row) > 0
                            }"
                        >
                            <span>
                                R$ {{ getGanhoPerda(row) | number : '1.2-2'}}
                            </span>
                        </div>
                        
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Rentabilidade" prop="volume_geral" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div                            
                            [ngClass]="{
                                'negativo': getRentabilidade(row) < 0 , 
                                'positivo': getRentabilidade(row) > 0
                            }"
                        >
                            <span>
                                {{ getRentabilidade(row) | number : '1.2-2'}} %
                            </span>
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="" prop="id" [sortable]="false" [width]="160">
                    <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                        <button 
                            mat-icon-button 
                            [matMenuTriggerFor]="actions"
                            matTooltip="Mostrar Opções"
                            *ngIf="_actions.buttonView.enabled || 
                            _actions.buttonEdit.enabled ||
                            _actions.buttonDelete.enabled"
                        >
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <!-- / ADD BUTTON -->
                        <mat-menu #actions="matMenu">
                            <button 
                                mat-menu-item 
                                matTooltip="Visualizar Dados do Cliente" 
                                (click)="viewClient(id)"  
                                *ngIf='_actions.buttonView.enabled'
                            >
                                <mat-icon aria-label="Editar">search</mat-icon>
                                VISUALIZAR
                            </button>

                            <button 
                                mat-menu-item 
                                matTooltip="Alterar Cliente" 
                                (click)="editClient(id)"
                                *ngIf='_actions.buttonEdit.enabled'
                            >
                                <mat-icon aria-label="Editar">edit</mat-icon>
                                EDITAR CADASTRO
                            </button>

                            <button 
                                mat-menu-item 
                                matTooltip="Excluir Cliente" 
                                *ngIf='_actions.buttonDelete.enabled'
                                (click)="delete(id)"                                
                            >
                                <mat-icon aria-label="Excluir Cliente">delete</mat-icon>
                                EXCLUIR
                            </button>
                        </mat-menu>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>